module.exports = __webpack_public_path__ + "static/media/LeftoverSalmonreuniontourRecherTheater9-20-2011Handdrawn4colorscreenprint.27821a42.webp";